import React from "react";
import { Box, Typography, Button, Grid, CircularProgress } from "@material-ui/core";

// Display-only pricing copy. The backend is the authority on the amount charged.
export const FREE_OCR_PAGE_LIMIT = 100;
export const OCR_RATE_PER_PAGE = 0.5;

const formatAmount = (amount) => `₹${Number(amount || 0).toFixed(2)}`;

export default function OcrPaymentStep({ paymentInfo, paying, onPay, onCancel, classes }) {
  const amount = paymentInfo?.amount;
  const totalPages = paymentInfo?.pages_requested;
  const freePages =
    paymentInfo?.free_pages ?? (totalPages ? Math.min(totalPages, FREE_OCR_PAGE_LIMIT) : undefined);
  const payablePages =
    paymentInfo?.payable_pages ??
    (totalPages > FREE_OCR_PAGE_LIMIT ? totalPages - FREE_OCR_PAGE_LIMIT : undefined);

  const rows = [
    { label: "Pages needing OCR", value: totalPages },
    { label: "Free pages", value: freePages },
    { label: "Payable pages", value: payablePages },
    { label: "Rate", value: `${formatAmount(OCR_RATE_PER_PAGE)} / page` },
  ].filter((row) => row.value !== undefined && row.value !== null);

  return (
    <>
      <Typography className={classes.bodyText}>
        {paymentInfo?.message ||
          `The first ${FREE_OCR_PAGE_LIMIT} pages are OCR'd for free. Beyond that a charge of ${formatAmount(
            OCR_RATE_PER_PAGE
          )} per page applies. Please complete the payment to continue.`}
      </Typography>

      <Box className={classes.paymentSummary}>
        {rows.map((row) => (
          <Typography key={row.label} className={classes.paymentRow}>
            <span>{row.label}</span>
            <span>{row.value}</span>
          </Typography>
        ))}
        <Typography className={`${classes.paymentRow} ${classes.paymentTotal}`}>
          <span>Amount payable</span>
          <span>{formatAmount(amount)}</span>
        </Typography>
      </Box>

      <Box height="2rem" />

      <Grid container justify="flex-end">
        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            className={classes.cancel}
            onClick={onCancel}
            disabled={paying}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.confirmBtn}
            onClick={onPay}
            disabled={paying}
          >
            {paying ? (
              <>
                <CircularProgress size={16} className={classes.spinner} />
                Processing...
              </>
            ) : (
              `Pay ${formatAmount(amount)}`
            )}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
